<template>
  <v-list-tile
    avatar
    ripple
    @click="$emit('onClick', transaction)"
    class="noPaddingLeft"
  >
    <v-list-tile-avatar style="min-width: 42px;">
      <v-icon
        :color="transaction.operation_type == 'debit' ? 'ctcRed' : 'ctcGreen'"
        >mdi-bank-{{
          transaction.operation_type == "debit" ? "minus" : "plus"
        }}</v-icon
      >
    </v-list-tile-avatar>

    <v-list-tile-content style="width: min-content;">
      <template v-if="two_line_variant == false">
        <v-list-tile-title style="width: 90%; line-height: 28px;">
          <span class="text--truncate">
            {{
              transaction.operation_type == "debit"
                ? "Beneficiary: "
                : "Applicant: "
            }}
            <!-- Bank name if amounbt == charges amount -->
            <strong
              v-if="
                transaction.charges_amount == transaction.amount
              "
              >{{ transaction.bank_information.name }}</strong
            >
            <strong v-else>{{
              transaction.company && transaction.company.name
            }}</strong>
          </span>
        </v-list-tile-title>
        <v-list-tile-sub-title style="white-space: nowrap;">
          <span style="font-size: 12px;">
            Ref:
            <strong>{{ transaction.reference }}</strong>
          </span>
        </v-list-tile-sub-title>
      </template>
      <template v-else>
        <v-list-tile-title style="white-space: nowrap;">
          <span class="text--truncate">
            Ref:
            <strong>{{ transaction.reference }}</strong>
          </span>
        </v-list-tile-title>
      </template>

      <v-list-tile-sub-title style="white-space: nowrap;">
        <v-layout row align-center class="ma-0">
          <span
            :class="
              'pr-3 caption font-weight-bold ' +
              (transaction.operation_type == 'debit' ? 'ctcRed' : 'ctcGreen') +
              '--text'
            "
            >{{ transaction.operation_type == "debit" ? "-" : "+"
            }}{{
              inCurrencyFromId(transaction.currency_id, transaction.amount)
            }}</span
          >

          <span
            v-if="
              transaction.operation_type == 'debit' &&
              transaction.charges_amount != 0
            "
            class="pr-3 caption font-weight-bold ctcRed--text"
            >(charges
            {{
              inCurrencyFromId(
                transaction.currency_id,
                transaction.charges_amount
              )
            }})</span
          >

          <span class="caption hidden-md-and-down text--truncate">
            <v-icon
              color="grey"
              size="12"
              style="position: relative; top: -1px;"
              >mdi-bank</v-icon
            >
            {{ transaction.bank_information.name }}
          </span>
        </v-layout>
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action
      v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm"
      style="min-width: fit-content;"
    >
      <v-list-tile-action-text>
        <span v-if="transaction.payment_date" style="white-space: nowrap;">
          <v-icon size="13" color="grey">update</v-icon>
          {{ timeToDate(transaction.payment_date) }}
        </span>
        <span v-else style="white-space: nowrap;">
          <v-icon size="13" color="error">warning</v-icon>
          <span class="error--text">Missing</span>
        </span>
        <br />
      </v-list-tile-action-text>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import currency from "../../../mixins/currency";
import date from "../../../mixins/date";

export default {
  name: "transactionListItem",
  mixins: [currency, date],
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    two_line_variant: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
<style lang="stylus">
.noPaddingLeft /deep/ a {
  padding-left: 6px;
}
</style>
